import { useEffect, useState } from "react";
import { Download, Smartphone } from "lucide-react";

export default function InstallPWAButton() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOSHint, setShowIOSHint] = useState(false);

  useEffect(() => {
    // iOS detection (iPhone / iPad Safari doesn't fire beforeinstallprompt)
    const ua = window.navigator.userAgent;
    const iosLike = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    setIsIOS(iosLike);
    // Already installed
    if (window.matchMedia("(display-mode: standalone)").matches) {
      setInstalled(true);
    }
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setInstalled(true));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (installed) return null;

  if (isIOS) {
    return (
      <>
        <button
          data-testid="pwa-install-ios-btn"
          onClick={() => setShowIOSHint(true)}
          className="inline-flex items-center gap-2 border border-black/15 hover:bg-black/5 rounded-xl h-10 px-4 text-xs font-medium transition-colors"
        >
          <Smartphone className="w-3.5 h-3.5" /> Installa su iPhone
        </button>
        {showIOSHint && (
          <div
            onClick={() => setShowIOSHint(false)}
            className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-4"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="bg-white rounded-xl p-6 max-w-sm w-full"
            >
              <div className="overline text-[#0A0A0A] mb-3">— INSTALLA SU IPHONE</div>
              <h3 className="font-display font-bold text-2xl tracking-tight mb-4">Aggiungi alla schermata Home</h3>
              <ol className="space-y-3 text-sm text-[#5C5C5C]">
                <li className="flex gap-3">
                  <span className="font-display font-bold text-[#0A0A0A] shrink-0">1.</span>
                  Tocca il pulsante <b>Condividi</b> nella barra di Safari (icona con freccia in su)
                </li>
                <li className="flex gap-3">
                  <span className="font-display font-bold text-[#0A0A0A] shrink-0">2.</span>
                  Scorri e scegli <b>Aggiungi a schermata Home</b>
                </li>
                <li className="flex gap-3">
                  <span className="font-display font-bold text-[#0A0A0A] shrink-0">3.</span>
                  Tocca <b>Aggiungi</b>. Archivio Smart apparirà come app.
                </li>
              </ol>
              <button
                onClick={() => setShowIOSHint(false)}
                className="mt-6 w-full rounded-xl bg-[#0A0A0A] hover:bg-[#1A1A1A] text-white h-10 text-sm font-medium"
              >
                Ho capito
              </button>
            </div>
          </div>
        )}
      </>
    );
  }

  if (!prompt) return null;
  return (
    <button
      data-testid="pwa-install-btn"
      onClick={async () => {
        prompt.prompt();
        const { outcome } = await prompt.userChoice;
        if (outcome === "accepted") setPrompt(null);
      }}
      className="inline-flex items-center gap-2 border border-black/15 hover:bg-black/5 rounded-xl h-10 px-4 text-xs font-medium transition-colors"
    >
      <Download className="w-3.5 h-3.5" /> Installa l'app
    </button>
  );
}
